(function () {
    'use strict';

    function isDisabledProduct(product) {
        if (!product || !product.tags) {
            return false;
        }
        
        let tags = product.tags;
        if (typeof tags === 'string') {
            tags = tags.split(',').map(tag => tag.trim());
        }
        
        if (!Array.isArray(tags)) {
            return false;
        }
        
        return tags.some(tag =>
            tag.toLowerCase() === 'disabled'
        );
    }

    function isUserLoggedIn() {
        return window.customer && window.customer.id;
    }

    function applyPDPBlur() {
        if (!isUserLoggedIn()) {
            const productContainer = document.querySelector('.product');
            if (productContainer && !productContainer.classList.contains('disabled')) {
                productContainer.classList.add('disabled');
                
                const clickHandler = function(e) {
                    if (e.target === productContainer || e.target.classList.contains('disabled')) {
                        e.preventDefault();
                        e.stopPropagation();
                        window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
                    }
                };
                
                productContainer.addEventListener('click', clickHandler, true);
            }
        }
    }

    function checkCurrentProduct() {
        if (isUserLoggedIn()) {
            return;
        }

        if (!window.location.pathname.includes('/products/')) {
            return;
        }

        const productScript = document.querySelector('script[data-product-json]');
        if (productScript) {
            try {
                const productData = JSON.parse(productScript.textContent);
                if (isDisabledProduct(productData)) {
                    applyPDPBlur();
                    return;
                }
            } catch (error) {
                console.debug('Error parsing inline product data:', error);
            }
        }

        if (window.product && isDisabledProduct(window.product)) {
            applyPDPBlur();
            return;
        }

        const existingProductScripts = document.querySelectorAll('script[type="application/json"][id*="ProductJSON"]');
        for (let script of existingProductScripts) {
            try {
                const productData = JSON.parse(script.textContent);
                if (isDisabledProduct(productData)) {
                    applyPDPBlur();
                    return;
                }
            } catch (error) {
                console.debug('Error parsing existing product JSON:', error);
            }
        }

        const productHandle = window.location.pathname.split('/products/')[1];
        if (productHandle && productHandle.length > 0) {
            const cleanHandle = productHandle.split('?')[0].split('#')[0]; // Remove query params and hash
            
            fetch(`/products/${cleanHandle}.js`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(productData => {
                    if (isDisabledProduct(productData)) {
                        applyPDPBlur();
                    }
                })
                .catch(error => {
                    console.debug('Error fetching product data:', error);
                });
        }
    }

    function init() {
        if (isUserLoggedIn()) {
            return;
        }

        checkCurrentProduct();
        
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    // Look for newly added product JSON scripts
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            if (node.matches && node.matches('script[data-product-json], script[id*="ProductJSON"]')) {
                                checkCurrentProduct();
                            }
                            const productScripts = node.querySelectorAll && node.querySelectorAll('script[data-product-json], script[id*="ProductJSON"]');
                            if (productScripts && productScripts.length > 0) {
                                checkCurrentProduct();
                            }
                        }
                    });
                }
            });
        });

        observer.observe(document.head, { childList: true, subtree: true });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(init, 100); // Small delay to ensure other scripts have loaded
        });
    } else {
        setTimeout(init, 100);
    }

    window.addEventListener('load', function() {
        setTimeout(init, 200);
    });
})();